<template>
  <div>
    <label class="text-xs font-black uppercase text-gray-600 block mb-2">🎨 Icône de la file</label>
    <div class="grid grid-cols-4 gap-3">
      <button
        v-for="icon in pharmacyIcons"
        :key="icon.name"
        type="button"
        @click="selectIcon(icon.name)"
        :class="[
          'p-4 rounded-xl border-2 transition-all hover:scale-105',
          selectedIcon === icon.name
            ? 'border-blue-500 bg-blue-50'
            : 'border-gray-200 bg-white hover:border-blue-300'
        ]"
        :title="icon.label"
      >
        <PharmacyIcon :name="icon.name" :size="32" :color="selectedIcon === icon.name ? '#3b82f6' : '#6b7280'" />
        <p class="text-[8px] font-bold mt-1 text-gray-500">{{ icon.label }}</p>
      </button>
    </div>
  </div>
</template>

<script>
import PharmacyIcon from './PharmacyIcons.vue'

export default {
  name: 'IconSelector',
  components: {
    PharmacyIcon
  },
  props: {
    modelValue: {
      type: String,
      default: 'pill'
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedIcon: this.modelValue,
      pharmacyIcons: [
        { name: 'prescription', label: 'Ordonnance' },
        { name: 'cross', label: 'Croix' },
        { name: 'capsule', label: 'Capsule' },
        { name: 'syringe', label: 'Seringue' },
        { name: 'heart-pulse', label: 'Cardiologie' },
        { name: 'stethoscope', label: 'Stéthoscope' },
        { name: 'microscope', label: 'Labo' },
        { name: 'flask', label: 'Analyse' },
        { name: 'thermometer', label: 'Température' },
        { name: 'bandage', label: 'Pansement' },
        { name: 'clipboard', label: 'Consultation' },
        { name: 'calendar', label: 'RDV' },
        { name: 'user-check', label: 'Patient' },
        { name: 'droplet', label: 'Vaccin' },
        { name: 'eye', label: 'Ophtalmologie' },
        { name: 'activity', label: 'Urgence' }
      ]
    }
  },
  watch: {
    modelValue(newVal) {
      this.selectedIcon = newVal
    }
  },
  methods: {
    selectIcon(iconName) {
      // ✅ Si l'icône est déjà sélectionnée, on la désélectionne (null)
      // Sinon, on la sélectionne
      if (this.selectedIcon === iconName) {
        this.selectedIcon = null
        this.$emit('update:modelValue', null)
      } else {
        this.selectedIcon = iconName
        this.$emit('update:modelValue', iconName)
      }
    }
  }
}
</script>
